module.exports = __webpack_public_path__ + "img/rubico_double.6c638a26.png";